// extracted by mini-css-extract-plugin
export var $animation_name = "BlogPostsSummary-module--$animation_name--b4fbe";
export var BlogPostsSummary = "BlogPostsSummary-module--BlogPostsSummary--d3b41";
export var BlogPostsSummary__subTitle = "BlogPostsSummary-module--BlogPostsSummary__subTitle--e80a7";
export var BlogPostsSummary__title = "BlogPostsSummary-module--BlogPostsSummary__title--c988d";
export var PostsContainer = "BlogPostsSummary-module--PostsContainer--5dd1d";
export var Wrapper = "BlogPostsSummary-module--Wrapper--1801e";